<template>
    <div>
        <div class="input-group basket-postcode__form">
            <input type="text" class="form-control basket-postcode__input" placeholder="e.g. WD18 9XT" v-model="postcode">
            <span class="input-group-btn">
                <button class="btn btn-blue basket-postcode__btn" type="button" @click="lookup">
                    <i class="fa fa-search" aria-hidden="true" v-if="!processing"></i>
                    <i class="fa fa-refresh fa-spin" aria-hidden="true" v-else></i>
                </button>
            </span>
        </div>
        <template v-if="!fetching && !processing">
            <template v-if="shipping">
                            </template>
            <template v-else>
                <i class="fa fa-refresh fa-spin"></i> Fetching estimated rate
            </template>
        </template>
        <template v-if="error">
            <hr>
            <div class="alert alert-warning">
                {{ error }}
            </div>
        </template>
    </div>
</template>

<script>
    import Postcode from '../../Services/Postcode.js';
    import Session from '../../Services/Session.js';
    import Basket from '../../Services/Basket.js';
    import Order from '../../Services/Order.js';
    import ProductPrice from '../Product/ProductPrice.vue';

    export default {
        components: {
            ProductPrice
        },
        props: {
            initial: {
                default: null,
                type: String
            }
        },
        data() {
            return {
                postcode: null,
                previousPostcode: null,
                error: null,
                basket: Basket,
                processing: false,
                orders: Order,
                shipping: null,
                fetching: true
            }
        },
        mounted() {
            if (getCookie('postcode')) {
                this.postcode = getCookie('postcode');
                this.lookup();
            }
        },
        methods: {
            validate() {
                const regex = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} ?[0-9][A-Z]{2}$/i;
                return regex.test(this.postcode);
            },
            lookup:  _.debounce(function() {
                if (!this.postcode) {
                    this.error = 'Please enter your postcode';
                    return;
                }

                // Try and validate the postcode a little to prevent bots?
                if (!this.validate()) {
                    this.error = 'We are unable to provide an estimated delivery for this postcode, please choose delivery quotation at checkout.';
                    return;
                }

                this.postcode = this.postcode.replace(/\s/g,'');

                if (this.previousPostcode == this.postcode) {
                    return;
                }

                this.error = null;
                this.processing = true;
                this.shipping = null;

                this.previousPostcode = this.postcode;

                Postcode.lookup(this.postcode, (errors, addresses) => {
                    // Save our lookup to the session...
                    this.processing = false;

                    if (!addresses) {
                        this.error = 'We are unable to check this postcode at this time.';
                    }

                    if (!addresses.length) {
                        this.error = 'We are unable to provide an estimated delivery for this postcode, please choose delivery quotation at checkout.';
                        return;
                    }

                    this.fetching = true;
                    this.orders.getEstimatedShipping(this.postcode, this.subTotal).then(response => {
                        if (!response.length) {
                            this.noResults = true;
                            // this.$emit('finished', true);
                            return;
                        }
                        if ((this.subTotal * 100) > response[0].min_basket) {
                            this.shipping = response[0];
                        } else {
                            this.shipping = response[1];
                        }


                        if (this.shipping.method.id == 'm2lrm9pq') {
                            this.error = 'We are unable to provide an estimated delivery for this postcode, please choose delivery quotation at checkout.';
                            return;
                        }

                        Postcode.setPostcode(this.postcode);
                        createCookie('postcode', this.postcode, 3200);
                        this.basket.setEstimatedShipping(this.shipping);
                        this.$emit('finished', true);
                        this.fetching = false;
                    });

                });
            }, 300)
        },
        computed: {
            subTotal() {
                return this.basket.basket.sub_total;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/PostcodeLookup.vue